import { render, staticRenderFns } from "./ProblemRectificationDrawer.vue?vue&type=template&id=181f90e0&scoped=true&"
import script from "./ProblemRectificationDrawer.vue?vue&type=script&lang=js&"
export * from "./ProblemRectificationDrawer.vue?vue&type=script&lang=js&"
import style0 from "./ProblemRectificationDrawer.vue?vue&type=style&index=0&id=181f90e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181f90e0",
  null
  
)

export default component.exports